import React from 'react';
import ComicButton from '../components/ui/ComicButton';
import { FiShoppingBag, FiHeart } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const merchItems = [
  { 
    id: 1, 
    name: "Funny Ole Hastings Mug", 
    price: "£12.00", 
    category: "Drinkware", 
    color: "bg-hcf-yellow",
    image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1770309988744-image.png"
  },
  { 
    id: 2, 
    name: "Norman Open Mic Tee", 
    price: "£20.00", 
    category: "Apparel", 
    color: "bg-hcf-cyan",
    image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1770309998111-image.png"
  },
  { 
    id: 3, 
    name: "Alien Fishing Hut Theft Print", 
    price: "£15.00", 
    category: "Art", 
    color: "bg-hcf-pink",
    image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1770310006844-image.png"
  },
  { 
    id: 4, 
    name: "One in the Eye Jumper", 
    price: "£35.00", 
    category: "Apparel", 
    color: "bg-hcf-purple",
    image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1770310015657-image.png"
  },
  { 
    id: 5, 
    name: "Norman Stand Up Mug", 
    price: "£12.00", 
    category: "Drinkware", 
    color: "bg-hcf-yellow",
    image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1770310027385-image.png"
  },
  { 
    id: 6, 
    name: "Funny Ole Hastings Zipped Hoodie", 
    price: "£45.00", 
    category: "Apparel", 
    color: "bg-hcf-cyan",
    image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1770310210677-image.png"
  },
  { 
    id: 7, 
    name: "Lizzie Mug", 
    price: "£12.00", 
    category: "Drinkware", 
    color: "bg-hcf-pink",
    image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1770310217722-image.png"
  },
  { 
    id: 8, 
    name: "One in the Eye Hoodie Black", 
    price: "£40.00", 
    category: "Apparel", 
    color: "bg-hcf-purple",
    image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1770310225130-image.png"
  },
  { 
    id: 9, 
    name: "One In the Eye Mug", 
    price: "£12.00", 
    category: "Drinkware", 
    color: "bg-hcf-yellow",
    image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1770310233154-image.png"
  },
];

const Merch = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      {/* Header */}
      <div className="flex flex-col md:flex-row items-center gap-8 mb-16">
        <div className="bg-black text-white p-6 border-4 border-hcf-pink shadow-comic transform -rotate-2">
          <h1 className="font-comic text-6xl md:text-7xl leading-none">OFFICIAL<br/><span className="text-hcf-yellow">MERCH</span></h1>
        </div>
        <div className="flex-grow">
          <div className="bg-hcf-cyan p-4 border-4 border-black shadow-comic-sm rotate-1">
            <p className="font-comic text-2xl text-black">WEAR THE LAUGHTER. DRINK THE CHAOS.</p>
          </div>
        </div>
      </div>

      {/* Merch Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {merchItems.map((item) => (
          <div key={item.id} className="group relative">
            <div className="absolute inset-0 bg-black translate-x-2 translate-y-2 rounded-lg"></div>
            <div className="relative bg-white border-4 border-black p-4 flex flex-col h-full transition-transform group-hover:-translate-y-1 group-hover:-translate-x-1">
              
              {/* Image Container */}
              <div className={`aspect-square ${item.color} border-4 border-black mb-4 relative overflow-hidden flex items-center justify-center bg-white`}>
                <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/comic-dots.png')] pointer-events-none z-10"></div>
                
                {item.image ? (
                   <img src={item.image} alt={item.name} className="w-full h-full object-contain p-2 relative z-0" />
                ) : (
                   <SafeIcon icon={FiShoppingBag} className="text-8xl text-black/20 relative z-0" />
                )}
                
                <div className="absolute top-2 left-2 bg-black text-white font-comic px-3 py-1 text-sm border-2 border-white rotate-[-5deg] z-20 shadow-sm">
                  {item.category}
                </div>
              </div>

              <h3 className="font-comic text-2xl mb-2 flex-grow leading-tight">{item.name}</h3>
              
              <div className="flex items-center justify-between mt-4">
                <span className="font-comic text-3xl text-hcf-pink">{item.price}</span>
                <ComicButton variant="primary" className="text-sm py-2 px-4 !shadow-comic-sm bg-hcf-yellow border-black">
                  ADD TO CART
                </ComicButton>
              </div>

              {/* Decorative Star */}
              <div className="absolute -top-3 -right-3 bg-hcf-pink text-white rounded-full p-2 border-2 border-black opacity-0 group-hover:opacity-100 transition-opacity z-30">
                <SafeIcon icon={FiHeart} />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Banner */}
      <div className="mt-24 bg-hcf-dark p-12 text-center border-8 border-black shadow-comic relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/halftone.png')] opacity-10"></div>
        <h2 className="font-comic text-4xl text-hcf-cyan mb-4 relative z-10">WORLDWIDE SHIPPING AVAILABLE</h2>
        <p className="font-body text-xl text-white max-w-2xl mx-auto relative z-10">
          All proceeds go towards supporting new comedy talent at the Hastings Comedy Festival. Support the stars of tomorrow, today!
        </p>
      </div>
    </div>
  );
};

export default Merch;